/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";

import { SearchBar, Button } from "UpduoLibrary";
import {
  skaleWhite,
  upduoLighterGray,
  upduoLightestGray,
  skalePrimaryBlue,
  upduoPrimaryBlue,
} from "config/UpduoColors";

import MemberTable from "./MemberTable";
import MemberProxyTable from "./MemberProxyTable";
import RolesTable from "./RolesTable";
import TableTabBar from "./TableTabBar";
import { MembersTableTabType } from "./types";

interface TableTabHeaderProps {
  memberName: string;
  tabChoice: MembersTableTabType;
  onTabChoice: (tab: MembersTableTabType) => void;
  onChangeSearchText: (text: string) => void;
  onPressExportCsvButton: () => void;
}

export default function TableTabHeader({
  memberName,
  tabChoice,
  onTabChoice,
  onChangeSearchText,
  onPressExportCsvButton,
}: TableTabHeaderProps) {
  return (
    <View
      style={{
        borderColor: upduoLightestGray,
        borderWidth: 1,
        borderRadius: 12,
      }}
    >
      <View
        style={{
          backgroundColor: skaleWhite,
          paddingLeft: "3%",
          paddingRight: 20,
          paddingVertical: 10,
          zIndex: 5,
          borderBottomWidth: 1,
          borderTopLeftRadius: 12,
          borderTopRightRadius: 12,
          borderColor: upduoLightestGray,
        }}
      >
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <TableTabBar
            memberName={memberName}
            tabChoice={tabChoice}
            onTabChoice={onTabChoice}
          />
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            {tabChoice !== "roles" ? (
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <View
                  style={{
                    marginRight: 15,
                  }}
                >
                  <SearchBar
                    placeholder={"Search Members"}
                    placeholderTextColor={upduoLighterGray}
                    onChangeText={onChangeSearchText}
                  />
                </View>
                <Button
                  onPress={onPressExportCsvButton}
                  text={"Export CSV"}
                  disabled={false}
                  height={36}
                  borderColor={skalePrimaryBlue}
                  color={upduoPrimaryBlue}
                />
              </View>
            ) : null}
          </View>
        </View>
      </View>
      {tabChoice === "members" ? <MemberTable /> : null}
      {tabChoice === "unregisteredMembers" ? <MemberProxyTable /> : null}
      {tabChoice === "roles" ? <RolesTable /> : null}
    </View>
  );
}
